import { Link, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useOIDCLogin } from "shared/hooks/useOIDCLogin";
import { CustomDialog } from "@web-applications/allinga-web-components";

function AccessDeniedNotification(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { auth } = useOIDCLogin();

  const emailId = "plattform@allinga-plattform.de";

  const handleOnClick = () => {
    auth.signoutRedirect();
    navigate("/");
  };

  const handleOpenEmail = () => {
    window.location.href = `mailto:${emailId}`;
  };

  return (
    <CustomDialog
      id="accessDenied"
      open
      showErrorIcon
      showDivider={false}
      header={t("access.accessDeniedLabel")}
      tertiaryButtonText={t("access.loginButton")}
      onTertiaryButtonClick={handleOnClick}
      maxWidth="xs"
      height="auto"
    >
      <Stack>
        <Typography>
          {t("access.accessDeniedTextLine1")}&nbsp;
          <Link
            color="primary"
            onClick={handleOpenEmail}
            sx={{ cursor: "pointer" }}
          >
            {emailId}
          </Link>
          {t("access.accessDeniedTextLine2")}
        </Typography>
      </Stack>
    </CustomDialog>
  );
}

export default AccessDeniedNotification;
